import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 66 — GoHighLevel vertical-industry cluster (second set) service links.
 *
 * Every Batch 66 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch66Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH66_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-for-hvac-companies": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no dispatch rule is a sub-account the dispatcher runs/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-real-estate-agents": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no instant reply is a sub-account that loses the buyer/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-dental-practices": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no rescue flow is a sub-account that loses the patient/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-law-firms": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no qualification gate is a sub-account that chases the wrong case/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-fitness-studios": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no save offer is a sub-account that loses the member/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
